import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DefinedRange, Calendar  } from 'react-date-range';
import moment from 'moment';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/core/styles';
import { defaultStaticRanges } from '../TransactionsMenu/DefaultRanges';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  dateField: {
    width: '70px',
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    color: '#333',
    fontSize: '.9em'
  },
  paddtingTop: {
    padding: '.5em'
  },
  paddingTo: {
    padding: '.5em .5em .5em 1em' 
  },
  datePickerContainer: {
    display: 'flex',
  }
});

const defaultSelection = { startDate: moment().add(1, 'day').toDate(), endDate: moment().add(1, 'day').toDate(), key: 'selection' };
class DateRange extends Component {

    state = {
      startDateOpen: false,
      endDateOpen: false,
      selection: defaultSelection,
    };

  handleClose = () => {
    this.setState({
      anchorEl: undefined,
      startDateOpen: false,
      endDateOpen: false
    });  
  }

  openStart = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      startDateOpen: true
    });  
  }
  
  openEnd = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      endDateOpen: true
    });  
  }

  handleStart = (date) => {
    if (!moment(date).isSame(this.props.dateRange.transactionsFrom)) {
        this.props.setDateRange({
            transactionsFrom: moment(date),
            transactionsTo: this.props.dateRange.transactionsTo
        });
    }
    this.setState({
      anchorEl: undefined,
      selection: defaultSelection,
      startDateOpen: false
    });  
  }

  handleEnd = (date) => {
    if (!moment(date).isSame(this.props.dateRange.transactionsTo)) {
        this.props.setDateRange({
            transactionsTo: moment(date).endOf('day'),
            transactionsFrom: this.props.dateRange.transactionsFrom
        });
    }
    this.setState({
      anchorEl: undefined,
      selection: defaultSelection,
      endDateOpen: false
    });  
  }

  handleRange = (range) => {
    if (range.selection !== this.state.selection) {
      this.props.setDateRange({
        transactionsFrom: moment(range.selection.startDate),
        transactionsTo: moment(range.selection.endDate).endOf('day')
      });
    }
    this.setState({
      anchorEl: undefined,
      startDateOpen: false,
      endDateOpen: false,
      selection: range.selection,
    });  
  }

  render() {
    const { classes } = this.props;
    const { transactionsFrom, transactionsTo } = this.props.dateRange;

    return (
        <form className={classes.container} >
          <div className={classes.paddtingTop}> From:</div>
          <div >
            <input className={classes.dateField} tabIndex={-1} name="startDate" type="text" value={transactionsFrom.format('DD MMM YY')} readOnly onClick={(e) => this.openStart(e)} />
          </div>

          <div className={classes.paddingTo}>To:</div>
          <div>
            <input className={classes.dateField} tabIndex={-1} name="endDate" type="text" value={transactionsTo.format('DD MMM YY')} readOnly onClick={(e) => this.openEnd(e)} />
          </div>
          <Popover
              open={this.state.startDateOpen}
              anchorEl={this.state.anchorEl}
              onClose={this.handleClose} >
              <div className={classes.datePickerContainer}>
                <DefinedRange
                  ranges={[this.state.selection]}
                  staticRanges={defaultStaticRanges}
                  inputRanges={[]}
                  onChange={this.handleRange}
                  className={undefined}
                />
                <Calendar
                  onChange={this.handleStart}
                  date={moment(transactionsFrom, 'DD MMM YY').toDate()}
                  minDate={moment().add(-1, 'years').toDate()}
                  maxDate={moment(transactionsTo, 'DD MMM YY').toDate()}
                  className={undefined}
                  />
              </div>
          </Popover>
          <Popover
              open={this.state.endDateOpen}
              anchorEl={this.state.anchorEl}
              onClose={this.handleClose} >
              <div className={classes.datePickerContainer}>
                <DefinedRange
                    ranges={[this.state.selection]}
                    staticRanges={defaultStaticRanges}
                    inputRanges={[]}
                    onChange={this.handleRange}
                    className={undefined}
                  />
                <Calendar
                  onChange={this.handleEnd}
                  date={moment(transactionsTo, 'DD MMM YY').toDate()}
                  minDate={moment(transactionsFrom, 'DD MMM YY').toDate()}
                  maxDate={moment().add(1, 'months').toDate()}
                  className={undefined}
                  />
                </div>
          </Popover>
      </form>
    );
  }
}

DateRange.propTypes = {
  setDateRange: PropTypes.func.isRequired
};

export default withStyles(styles)(DateRange);



// WEBPACK FOOTER //
// ./src/components/Transaction/DateRange.js